module.exports = __webpack_public_path__ + "img/bcg-right.9c007558.png";